const STARTUP_ROLES = {
  CEO: 'ceo',
  CO_FOUNDER: 'co_founder',
  STAFF: 'staff',
  LEADER: 'leader',
  INVESTOR_LEADER: 'investor_leader',
  BMC_LEADER: 'bmc_leader',
  FREELANCER: 'freelancer',
  BOARD_MEMBER: 'board_member', // THIS ROLE REFERS TO A MEMBER OF A BOARD, SUCH AS A TASKS BOARD. IT IS NOT RELATED TO A STARTUP DIRECTORS BOARD WHATSOEVER
  BOARD_OF_DIRECTOR: 'board_of_director',
  ADVISORY_BOARD: 'advisory_board',
  ADVISORY_SERVICE: 'advisory_service',
  INVESTOR: 'investor',
  MENTOR: 'mentor',
  ADVISOR: 'advisor',
  GUEST: 'guest',
};

export { STARTUP_ROLES };
